import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "@progress/kendo-theme-bootstrap/dist/all.css";
import "@axum/ax-design/dist/css/ax-design.css";
import "@axum/ax-design/dist/css/ax-design-kendo.css";
import store from "./redux/store";

import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider,
} from "@progress/kendo-react-intl";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import numbers from "cldr-numbers-full/main/es/numbers.json";
import caGregorian from "cldr-dates-full/main/es/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/es/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/es/timeZoneNames.json";

import { languageContext, languages } from "./config/language";
import esMessages from "./config/language/kendo.es.json";

// component
import App from "./view/App";

declare global {
  interface Window {
    dashboardComponentCode: string;
    prefijo: string;
    api: string;
    orders360Embedded:boolean;
  }
}

const currentLanguage = "es";
const language = languages[currentLanguage];

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  caGregorian,
  dateFields,
  timeZoneNames
);

loadMessages(esMessages, "es");

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <languageContext.Provider value={{ languageContext: language }}>
        <LocalizationProvider language="es">
          <IntlProvider locale={"es"}>
            <App />
          </IntlProvider>
        </LocalizationProvider>
      </languageContext.Provider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);